/**
 * Created by sudhir on 2/17/2017.
 */
var ModalPopupService = /** @class */ (function () {
    /*@ngInject*/
    function ModalPopupService($mdDialog) {
        this.$mdDialog = $mdDialog;
    }
    ModalPopupService.prototype.showPopup = function (ev, templateName, modalController, params) {
        var self = this;
        //contentElement: '#' + templateName,
        //contentElement: document.querySelector('#' + templateName),
        return self.$mdDialog.show({
            multiple: true,
            controller: modalController,
            controllerAs: 'pop',
            locals: { params: params },
            templateUrl: templateName,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        })
            .then(function (answer) {
            console.log('Answer in showAddress is ->', answer);
            return answer;
        }, function () {
            console.log('You cancelled the dialog.');
            return null;
        });
    };
    ;
    return ModalPopupService;
}());
export default ModalPopupService;
//# sourceMappingURL=modal-popup.service.js.map